import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { xepLoaiHocTapApi } from "../../../api/category/xepLoaiHocTapApi";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { rootActions } from "../../actions/rootActions";
import { eXepLoaiHocTapActionIds, IXepLoaiHocTapActionTypes } from "../../action-types/category/IXepLoaiHocTapActions";
import { IXepLoaiHocTap } from "../../../model/response/category/IXepLoaiHocTap";
const mainAction= rootActions.category.xepLoaiHocTap;

export function* xepLoaiHocTapSaga(): any {
    yield takeLatest(eXepLoaiHocTapActionIds.LOAD_START, loadWorker);
    yield takeEvery(eXepLoaiHocTapActionIds.SAVE_START, saveWorker);
    yield takeEvery(eXepLoaiHocTapActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
    const res = yield call(xepLoaiHocTapApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải Xếp loại học tập"));
    }
}

function* saveWorker(action: IXepLoaiHocTapActionTypes): any {
    let res;
    const payload = action.payload as IXepLoaiHocTap;
    if (payload.id_xep_loai > 0) {
        res = yield call(xepLoaiHocTapApi.Update, payload.id_xep_loai, payload);
    } else {
        res = yield call(xepLoaiHocTapApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu Xếp loại học tập"));
    }
}

function* deleteWorker(action: IXepLoaiHocTapActionTypes): any {
    const id = action.payload as number;
    const res = yield call(xepLoaiHocTapApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa Xếp loại học tập"));
    }
}